// frontend/src/pages/AdminAnalytics.jsx
import React from 'react';
import { PresentationChartLineIcon } from '@heroicons/react/24/outline';

const AdminAnalytics = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="flex justify-center items-center w-10 h-10 bg-green-100 rounded-lg">
          <PresentationChartLineIcon className="w-6 h-6 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
      </div>
      <div className="card">
        <div className="card-content">
          <p className="text-gray-600">Analytics dashboard coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default AdminAnalytics;